// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const ProposalGap = zod.object({
  "field": zod.string(),
  "reason": zod.string()
});

export type ProposalGap = zod.input<typeof ProposalGap>;
export type ProposalGapOutput = zod.output<typeof ProposalGap>;
